// scroll down -> site title hides, navs hide √
// scroll up -> site title shows, navs show √
// mousemove top -> top navs show, site title shows if site title is pos top
// mousemove bottom -> bottoms navs show, site title shows if site title is pos bottom
// when scrolling down, navbar hides
// when scrolling up, navbar shows

import { Utility } from '../utility/utility_controller'
import get_navshowhide_instances from './showhide_onscroll_nav'
import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'

// var documentHeight = document.documentElement.scrollHeight

// show, hide for nav and sitetitle when scrolling

var showhide_onscroll_controller = {
	i: function () {
		i()
	},
	showAll: function () {
		showAll()
	},
	hideAll: function () {
		hideAll()
	},
	setJqueryMap: function () {
		setJqueryMap()
	},
	hideSt: function () {
		hideSt()
	},
	hideNav: function () {
		hideAllNavs()
		// dont rlly need this but in fullscreen slider i accidentally use this function
	},
	hideNavBar: function () {
		hideNavbar()
	},
	showSt: function () {
		showSt()
	},
	getStPos: function () {
		return getStPos()
	},
}

export default showhide_onscroll_controller

// safety offset needed for things like prevent "y" character bottom-part showing
var configMap = {
		safetyOffset: 20,
		scrollThreshold: 50,
	},
	stateMap = {
		oldScrollY: 0,
		stheight: 0,
		st_pos: 'top',
		st_hidewhenscrollingdown: false,
		st_fadeout_whenscrollingdown: false,
		st_exists: true,
		navbar_exists: true,
		navbar_hidewhenscrollingdown: false,
		navbar_fadeout_whenscrollingdown: false,
		second_navbar_exists: false,
		second_navbar_position: 'top',
		second_navbar_hidewhenscrollingdown: false,
		second_navbar_fadeout_whenscrollingdown: false,
		mouseover_target_area_bottom: 0,
		mouseover_target_area_top: 0,
	},
	jqueryMap = {
		$navbar: null,
		$secondNavbar: null,
		$st: null,
	}

// The desktop header chrome (navs, site title, navbar) is shown when the
// viewport is wider than the MENU breakpoint (`phone_menu_breakpoint`).
// Below it, the mobile burger menu takes over (see
// scss/phone_menu_breakpoint_under/style.scss: .sitetitle/nav.primary become
// display:none, .navbar becomes the mobile bar). This is a SEPARATE setting
// from the CONTENT breakpoint (`layData.breakpoint`) behind
// `Utility.isDesktopOrTabletSize` — gating the header show/hide on the content
// breakpoint leaves a viewport range where the desktop header is visible but
// never hides/fades on scroll.
var isDesktopMenuVisible = function () {
	return window.innerWidth > Utility.phoneMenuBreakpoint
}

var getStPos = function () {
	return stateMap.st_pos
}

var showSt = function () {
	if ((stateMap.st_hidewhenscrollingdown || stateMap.st_fadeout_whenscrollingdown) && stateMap.st_exists) {
		if (window.lay_lightbox_opened == false || typeof window.lay_lightbox_opened == 'undefined') {
			if (jqueryMap.$st.hasClass('hidden')) {
				jqueryMap.$st.removeClass('hidden').css({ transform: '', 'pointer-events': '', opacity: '' })
			}
		}
	}
}

var hideOverlayBurgers = function () {
	jQuery('a.overlay-burger[data-lay-burger-hide-on-scroll], a.overlay-burger[data-lay-burger-fade-on-scroll]').each(function () {
		var $el = jQuery(this)
		var hideMove = $el.attr('data-lay-burger-hide-on-scroll') === '1'
		var hideFade = $el.attr('data-lay-burger-fade-on-scroll') === '1'
		if (!hideMove && !hideFade) {
			return
		}
		if ($el.hasClass('hidden')) {
			return
		}
		if (hideMove) {
			var rect = this.getBoundingClientRect()
			// Burgers anchored to the bottom of the viewport translate DOWN
			// off-screen (translateY positive); top-anchored ones translate
			// UP (negative). Computed `bottom` can be a pixel value even when
			// CSS authored `bottom:auto`, so compare the actual viewport gaps.
			var isBottomAnchored = rect.top > window.innerHeight - rect.bottom
			if (isBottomAnchored) {
				var hDown = (window.innerHeight - rect.top) + configMap.safetyOffset
				$el.css('transform', 'translateY(' + hDown + 'px)')
			} else {
				var h = rect.bottom + configMap.safetyOffset
				$el.css('transform', 'translateY(-' + h + 'px)')
			}
		}
		if (hideFade) {
			$el.css({ opacity: 0, 'pointer-events': 'none' })
		}
		$el.addClass('hidden')
	})
}

var showOverlayBurgers = function () {
	if (window.lay_lightbox_opened == true && typeof window.lay_lightbox_opened != 'undefined') {
		return
	}
	jQuery('a.overlay-burger[data-lay-burger-hide-on-scroll], a.overlay-burger[data-lay-burger-fade-on-scroll]').each(function () {
		var $el = jQuery(this)
		if ($el.hasClass('hidden')) {
			$el.removeClass('hidden').css({ transform: '', 'pointer-events': '', opacity: '' })
		}
	})
}

var hideSt = function () {
	if ((stateMap.st_hidewhenscrollingdown || stateMap.st_fadeout_whenscrollingdown) && isDesktopMenuVisible() && stateMap.st_exists) {
		if (!jqueryMap.$st.hasClass('hidden')) {
			if (stateMap.st_hidewhenscrollingdown) {
				var x = 0
				if (layData.st_position.indexOf('center') != -1) {
					x = '-50%'
				}

				var rect = jqueryMap.$st[0].getBoundingClientRect()
				if (stateMap.st_pos == 'center') {
					var bottom = rect.bottom
					var h = jqueryMap.$st.outerHeight()
					if (jqueryMap.$st.find('.sitetitle-txt-inner>span').length > 0) {
						var h2 = jqueryMap.$st.find('.sitetitle-txt-inner>span').outerHeight()
						if (h2 > h) {
							h = h2
							bottom = jqueryMap.$st.find('.sitetitle-txt-inner>span')[0].getBoundingClientRect().bottom
						}
					}
					// because we also have top: 50% in CSS, we need to take 50% more of h for correct translate valuie
					var val = bottom + h / 2
					jqueryMap.$st.css('transform', 'translate(' + x + ',-' + val + 'px)')
				} else if (stateMap.st_pos == 'top') {
					var h = rect.bottom + configMap.safetyOffset
					jqueryMap.$st.css('transform', 'translate(' + x + ',-' + h + 'px)')
				} else if (stateMap.st_pos == 'bottom') {
					var h = window.innerHeight - rect.top + configMap.safetyOffset
					jqueryMap.$st.css('transform', 'translate(' + x + ',' + h + 'px)')
				}
			}
			if (stateMap.st_fadeout_whenscrollingdown) {
				jqueryMap.$st.css({ opacity: 0, 'pointer-events': 'none' })
			}

			jqueryMap.$st.addClass('hidden')
		}
	}
}

var bindScroll = function () {
	window.eventsChannel.on('scroll', function (scrollTop, scrollHeight, scrollContext) {
		if (scrollContext && scrollContext.source === 'page-overlay') {
			return
		}
		var scrollY = scrollTop
		var isInScrollableRange = scrollY > 0 && scrollY < scrollHeight - window.innerHeight

		if (isInScrollableRange) {
			// Desktop header chrome (navs, site title, navbar) hides/shows on
			// scroll only while the desktop menu is visible — gate on the MENU
			// breakpoint, not the content breakpoint (see isDesktopMenuVisible).
			// Overlay burgers are independent and stay outside the gate.
			if (scrollY > stateMap.oldScrollY && scrollY > configMap.scrollThreshold) {
				stateMap.startedScrollingUpY = scrollY
				if (isDesktopMenuVisible()) {
					hideAllNavs()
					hideSt()
					hideNavbar()
				}
				hideOverlayBurgers()
			}
			if (scrollY < stateMap.oldScrollY && scrollY < stateMap.startedScrollingUpY - configMap.scrollThreshold / 2) {
				if (isDesktopMenuVisible()) {
					showAllNavs()
					showSt()
					showNavbar()
				}
				showOverlayBurgers()
			}
			if (scrollY < configMap.scrollThreshold) {
				if (isDesktopMenuVisible()) {
					showAllNavs()
					showSt()
					showNavbar()
				}
				showOverlayBurgers()
			}
			stateMap.oldScrollY = scrollY
		}
	})

	jQuery(window).on('fpOnLeave', function (event, obj) {
		switch (obj.direction) {
			case 'up':
				showAllNavs()
				showSt()
				showOverlayBurgers()
				showNavbar()
				break
			case 'down':
				hideAllNavs()
				hideSt()
				hideOverlayBurgers()
				hideNavbar()
				break
		}
	})
}

var hideAllNavs = function () {
	var navshowhide_instances = get_navshowhide_instances()
	for (var i = 0; i < navshowhide_instances.length; i++) {
		navshowhide_instances[i].hide()
	}
}

var showAllNavs = function () {
	var navshowhide_instances = get_navshowhide_instances()
	for (var i = 0; i < navshowhide_instances.length; i++) {
		navshowhide_instances[i].show()
	}
}

var setJqueryMap = function () {
	if (stateMap.navbar_exists) {
		jqueryMap.$navbar = jQuery('.navbar')
	}
	if (stateMap.second_navbar_exists) {
		jqueryMap.$secondNavbar = jQuery('.navbar-second-menu')
	}
	if (stateMap.st_exists) {
		jqueryMap.$st = jQuery('.sitetitle')
	}
}

var hideNavbarElement = function ($navbar, exists, hideWhenScrolling, fadeWhenScrolling, position) {
	if (!exists || (!hideWhenScrolling && !fadeWhenScrolling) || !isDesktopMenuVisible() || $navbar === null || $navbar.length === 0) {
		return
	}
	if (!$navbar.hasClass('hidden')) {
		if (hideWhenScrolling) {
			var height = $navbar[0].getBoundingClientRect().height + configMap.safetyOffset
			var direction = position == 'top' ? -1 : 1
			$navbar.css('transform', 'translateY(' + direction * height + 'px)')
		}
		if (fadeWhenScrolling) {
			$navbar.css({ opacity: 0, 'pointer-events': 'none' })
		}
		$navbar.addClass('hidden')
	}
}

var showNavbarElement = function ($navbar, exists, hideWhenScrolling, fadeWhenScrolling) {
	if (!exists || (!hideWhenScrolling && !fadeWhenScrolling) || $navbar === null || $navbar.length === 0) {
		return
	}
	if (window.lay_lightbox_opened == false || typeof window.lay_lightbox_opened == 'undefined') {
		$navbar.removeClass('hidden').css({ transform: '', 'pointer-events': '', opacity: '1' })
	}
}

var hideNavbar = function () {
	hideNavbarElement(jqueryMap.$navbar, stateMap.navbar_exists, stateMap.navbar_hidewhenscrollingdown, stateMap.navbar_fadeout_whenscrollingdown, layData.navbar_position)
	hideNavbarElement(jqueryMap.$secondNavbar, stateMap.second_navbar_exists, stateMap.second_navbar_hidewhenscrollingdown, stateMap.second_navbar_fadeout_whenscrollingdown, stateMap.second_navbar_position)
}

var showNavbar = function () {
	showNavbarElement(jqueryMap.$navbar, stateMap.navbar_exists, stateMap.navbar_hidewhenscrollingdown, stateMap.navbar_fadeout_whenscrollingdown)
	showNavbarElement(jqueryMap.$secondNavbar, stateMap.second_navbar_exists, stateMap.second_navbar_hidewhenscrollingdown, stateMap.second_navbar_fadeout_whenscrollingdown)
}

var showNavbarAtPosition = function (position) {
	if (layData.navbar_position == position) {
		showNavbarElement(jqueryMap.$navbar, stateMap.navbar_exists, stateMap.navbar_hidewhenscrollingdown, stateMap.navbar_fadeout_whenscrollingdown)
	}
	if (stateMap.second_navbar_position == position) {
		showNavbarElement(jqueryMap.$secondNavbar, stateMap.second_navbar_exists, stateMap.second_navbar_hidewhenscrollingdown, stateMap.second_navbar_fadeout_whenscrollingdown)
	}
}

// still need this for mouseover area
var setStHeight = function () {
	stateMap.stheight = 0
	if (stateMap.st_exists && (stateMap.st_hidewhenscrollingdown || stateMap.st_fadeout_whenscrollingdown)) {
		var h = jqueryMap.$st.outerHeight()
		if (jqueryMap.$st.find('.sitetitle-txt-inner>span').length > 0) {
			var h2 = jqueryMap.$st.find('.sitetitle-txt-inner>span').outerHeight()
			if (h2 > h) {
				h = h2
			}
		}
		if (stateMap.st_pos == 'top' || stateMap.st_pos == 'center') {
			h += jqueryMap.$st[0].getBoundingClientRect().top
		} else if (stateMap.st_pos == 'bottom') {
			h += window.innerHeight - jqueryMap.$st[0].getBoundingClientRect().bottom
		}
		h += configMap.safetyOffset
		stateMap.stheight = h
	}
}

var bindWindowResize = function () {
	// cause navheight changes when u are in smartphone view
	jQuery(window).on(
		'window_width_changed',
		debounce(function () {
			// documentHeight = document.documentElement.scrollHeight
			setStHeight()
			var navshowhide_instances = get_navshowhide_instances()
			for (var i = 0; i < navshowhide_instances.length; i++) {
				navshowhide_instances[i].set_height_and_space_around()
			}
		}, 300)
	)
}

// mousemove shows nav. if sitetitle and nav have same position, sitetitle is also shown
var bindMouseMove = function () {
	jQuery(window).on(
		'mousemove',
		throttle(function (e) {
			// Same gate as the scroll handler: reveal-on-mouseover applies to the
			// desktop header chrome, which exists above the MENU breakpoint.
			if (isDesktopMenuVisible()) {
				var navshowhide_instances = get_navshowhide_instances()
				if (e.clientY <= stateMap.mouseover_target_area_top) {
					// show menus at top
					for (var i = 0; i < navshowhide_instances.length; i++) {
						navshowhide_instances[i].show_on_mouseover('top')
					}
					// show site title at top
					if (stateMap.st_pos == 'top') {
						showSt()
					}
					showOverlayBurgers()
					// show menu bar at top
					showNavbarAtPosition('top')
				}
				if (e.clientY >= window.innerHeight - stateMap.mouseover_target_area_bottom) {
					// show menus at bottom
					for (var i = 0; i < navshowhide_instances.length; i++) {
						navshowhide_instances[i].show_on_mouseover('bottom')
					}
					// show site title at bottom
					if (stateMap.st_pos == 'bottom') {
						showSt()
					}
					// show menu bar at bottom
					showNavbarAtPosition('bottom')
				}
			}
		}, 100)
	)
}

// get the top area that will trigger "show everything at top". this is the max area
var setMouseoverTopMaxArea = function () {
	// get max height+margintop
	var maxH = 0
	// site title top?
	if (stateMap.st_pos == 'top') {
		maxH = stateMap.stheight
	}
	// menus top?
	var navshowhide_instances = get_navshowhide_instances()
	for (var i = 0; i < navshowhide_instances.length; i++) {
		if (navshowhide_instances[i].nav_position.indexOf('top') != -1) {
			var space = navshowhide_instances[i].height_and_space_around
			if (space > maxH) {
				maxH = space
			}
		}
	}
	// menu bar top?
	if (layData.navbar_position == 'top' && stateMap.navbar_exists) {
		var navbar_h = jqueryMap.$navbar.height()
		maxH = maxH < navbar_h ? navbar_h : maxH
	}
	if (stateMap.second_navbar_position == 'top' && stateMap.second_navbar_exists) {
		var second_navbar_h = jqueryMap.$secondNavbar.height()
		maxH = maxH < second_navbar_h ? second_navbar_h : maxH
	}
	stateMap.mouseover_target_area_top = maxH
}

var setMouseoverBottomMaxArea = function () {
	// get max height+margintop
	var maxH = 0
	// site title bottom?
	if (stateMap.st_pos == 'bottom') {
		maxH = stateMap.stheight
	}
	// menus bottom?
	var navshowhide_instances = get_navshowhide_instances()
	for (var i = 0; i < navshowhide_instances.length; i++) {
		if (navshowhide_instances[i].nav_position.indexOf('bottom') != -1) {
			var space = navshowhide_instances[i].height_and_space_around
			if (space > maxH) {
				maxH = space
			}
		}
	}
	// menu bar bottom?
	if (layData.navbar_position == 'bottom' && stateMap.navbar_exists) {
		var navbar_h = jqueryMap.$navbar.height()
		maxH = maxH < navbar_h ? navbar_h : maxH
	}
	if (stateMap.second_navbar_position == 'bottom' && stateMap.second_navbar_exists) {
		var second_navbar_h = jqueryMap.$secondNavbar.height()
		maxH = maxH < second_navbar_h ? second_navbar_h : maxH
	}
	stateMap.mouseover_target_area_bottom = maxH
}

var i = function () {
	if (layData.st_position.indexOf('top') != -1) {
		stateMap.st_pos = 'top'
	} else if (layData.st_position.indexOf('bottom') != -1) {
		stateMap.st_pos = 'bottom'
	} else {
		stateMap.st_pos = 'center'
	}

	if (layData.st_hidewhenscrollingdown == 1) {
		stateMap.st_hidewhenscrollingdown = true
	} else {
		stateMap.st_hidewhenscrollingdown = false
	}

	if (layData.st_fadeout_whenscrollingdown == 1) {
		stateMap.st_fadeout_whenscrollingdown = true
	} else {
		stateMap.st_fadeout_whenscrollingdown = false
	}

	if (layData.st_hide == 1) {
		stateMap.st_exists = false
	} else {
		stateMap.st_exists = true
	}

	if (layData.navbar_hide == 1) {
		stateMap.navbar_exists = false
	} else {
		stateMap.navbar_exists = true
	}

	if (layData.navbar_fadeout_whenscrollingdown == 1) {
		stateMap.navbar_fadeout_whenscrollingdown = true
	} else {
		stateMap.navbar_fadeout_whenscrollingdown = false
	}

	if (layData.navbar_hidewhenscrollingdown == 1) {
		stateMap.navbar_hidewhenscrollingdown = true
	} else {
		stateMap.navbar_hidewhenscrollingdown = false
	}

	stateMap.second_navbar_position = layData.navbar_position_second_menu || 'top'
	stateMap.second_navbar_exists = layData.navbar_hide_second_menu != 1 && jQuery('.navbar-second-menu').length > 0
	stateMap.second_navbar_fadeout_whenscrollingdown = layData.navbar_fadeout_whenscrollingdown_second_menu == 1
	stateMap.second_navbar_hidewhenscrollingdown = layData.navbar_hidewhenscrollingdown_second_menu == 1

	setJqueryMap()
	setStHeight()

	bindScroll()
	bindWindowResize()

	// Only bind mouse move if the setting is enabled
	if (typeof layData !== 'undefined' && layData.mouseover_show_scroll_hidden === 'on') {
		bindMouseMove()
	}

	setMouseoverTopMaxArea()
	setMouseoverBottomMaxArea()

	if (jQuery('.sitetitle').hasClass('img')) {
		var img = jQuery('.sitetitle img')[0]
		if (img.complete) {
			setStHeight()
		} else {
			img.onload = function () {
				setStHeight()
			}
		}
	}

	window.laytheme.on('newpageshown', function () {
		showAll()
	})
}

// hide everything, its a function that gets called publicly. before it only needed to hide nav but now it needs to hide site title too
var hideAll = function () {
	hideAllNavs()
	hideSt()
	hideOverlayBurgers()
	// i have no idea why, but if i dont do this we get an error sometimes! when magnetic slides plugin is active
	if (typeof hideNavBar == 'function') {
		hideNavBar()
	}
}

// show everything, its a function that gets called publicly. before it only needed to show nav but now it needs to show site title too
var showAll = function () {
	showAllNavs()
	showSt()
	showOverlayBurgers()
	showNavbar()
}
